import { DealEventActivityViewModel } from '@trnsact/trnsact-shared-types';

export enum CalendarView {
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Table = 'table',
}

export enum EventCardMode {
  Read = 'read',
  Write = 'write',
}

export interface CalendarEventCardProps {
  onSwitchMode: VoidFunction;
  event: DealEventActivityViewModel;
}

export interface CalendarViewComponentProps {
  date: Date;
  onNavigate: (date: Date) => void;
}
